var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"job-market-container"},[_c('SearchHeader'),_vm._v(" "),_c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"row gy-6 gx-6"},[_c('div',{staticClass:"col"},[_c('SearchResults')],1)])]),_vm._v(" "),_c('SearchFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }